<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_663_5733"
      style="mask-type: alpha;"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_663_5733)"></g>
    <g clip-path="url(#clip0_663_5733)">
      <path
        d="M14.9 13.1C14.2 13.1 13.61 12.86 13.13 12.37C12.65 11.89 12.4 11.29 12.4 10.6C12.4 9.91 12.64 9.31 13.13 8.83C13.61 8.35 14.21 8.1 14.9 8.1C15.59 8.1 16.19 8.34 16.67 8.83C17.15 9.32 17.4 9.91 17.4 10.6C17.4 11.29 17.16 11.89 16.67 12.37C16.19 12.85 15.59 13.1 14.9 13.1ZM8.3 16.2C7.8 16.2 7.38 16.02 7.02 15.67C6.66 15.32 6.49 14.89 6.49 14.39V6.81C6.49 6.31 6.67 5.89 7.02 5.53C7.37 5.18 7.8 5 8.3 5H21.49C21.99 5 22.41 5.18 22.77 5.53C23.12 5.88 23.3 6.31 23.3 6.81V14.39C23.3 14.89 23.12 15.31 22.77 15.67C22.42 16.02 21.99 16.2 21.49 16.2H8.31H8.3ZM9.8 14.7H19.99C19.99 14.2 20.17 13.78 20.52 13.42C20.87 13.07 21.3 12.89 21.8 12.89V8.31C21.3 8.31 20.88 8.13 20.52 7.78C20.17 7.43 19.99 7 19.99 6.5H9.81C9.81 7 9.63 7.42 9.28 7.78C8.93 8.14 8.5 8.31 8 8.31V12.89C8.5 12.89 8.92 13.07 9.28 13.42C9.63 13.77 9.81 14.2 9.81 14.7H9.8ZM20.32 19.7H4.81C4.31 19.7 3.89 19.52 3.53 19.17C3.18 18.82 3 18.39 3 17.89V7.98H4.5V17.88C4.5 17.96 4.53 18.03 4.6 18.09C4.66 18.15 4.73 18.19 4.81 18.19H20.33V19.69L20.32 19.7ZM8.3 14.7H7.99V6.5H8.3C8.22 6.5 8.14 6.53 8.08 6.59C8.02 6.65 7.99 6.72 7.99 6.81V14.39C7.99 14.47 8.02 14.55 8.08 14.61C8.14 14.67 8.21 14.7 8.3 14.7Z"
        fill="#1E264C"
      />
    </g>
    <defs>
      <clipPath id="clip0_663_5733">
        <rect
          width="20.31"
          height="14.69"
          fill="white"
          transform="translate(3 5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
